export default class AMName {

    private static AM_NAMES = [
        "RS",
        "M_Z",
        "UPLOAD_PIC",
        "UPLOAD_VIS",
        "UPLOAD_S_N",
        "CAL_BLANKS",
        "SD_6SPIKE",
        "CAL_Y",
        "CAL_RES",
        "CCA_CCB_HOMO",
        "CCA_CCB_HETERO",
        "_1_5_1",
        "_1_5_3",
        "_3_5_1",
        "_1_6_1",
        "_2_6_1",
        "_3_6_2",
        "_1_1_6",
        "ACC_1_4_5",
        "PREC_1_4_5",
        "_2_1_6",
        "_2_3_3",
        "ACC_1_3_3",
        "PREC_1_3_3",
        "REF_SAMP",
        "REF_METHOD",
        "_1_1_10",
        "ACC_3_4_1",
        "PREC_3_4_1"
    ];

    static getAMNameFromAMCodeName(code_name:string){
        let lastColonIndex = code_name.lastIndexOf(":")
        let name = code_name.substring(lastColonIndex + 1).toUpperCase();
        if(AMName.isNumericChar(name.substring(0,1))){
            name = "_" + name;
        }
        if(AMName.AM_NAMES.indexOf(name) == -1){
            let firstColonIndex = code_name.indexOf(":");
            let param = code_name.substring(0, firstColonIndex).toUpperCase();
            name = param + name;
        }
        if(AMName.AM_NAMES.indexOf(name) == -1){
            throw new Error("No such code_name!")
        }
        return name;

    }

    static isNumericChar(strNum:string) {
        if (strNum == null) {
            return false;
        }
        return strNum.match("[0-9]") != null;
    }
}
